import { faPenToSquare, faPlus, faTrashCan, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom';
import Pagination from '../../components/layout/Pagination'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

function CarFilterConnectionTest1() {
    const [product, setProduct] = useState(null)
    const [loading, setLoading] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [carManufacturers, setCarManufacturers] = useState([])
    const [carModels, setCarModels] = useState([])
    const [carEngines, setCarEngines] = useState([])
    const [selectedCarManufacuturer, setSelectedCarManufacuturer] = useState('')
    const [selectedCarModel, setSelectedCarModel] = useState('')
    const [selectedEngineId, setSelectedEngineId] = useState('')
    const [description, setDescription] = useState('')
    const [newCarConnection, setNewCarConnection] = useState({})
    const [carConnections, setCarConnections] = useState([])
    const [carToDelete, setCarToDelete] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedCar, setSelectedCar] = useState([])
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortBy, setSortBy] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const token = localStorage.getItem('authToken');
    const { id } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const location = useLocation()
    const navigate = useNavigate();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const sortByUrl = queryParams.get('sortBy') ?? '';
        const pageSizeUrl = queryParams.get('pageSize') ?? pageSize;
        const currentPageUrl = queryParams.get('currentPage') ?? 1;
        const totalPagesUrl = queryParams.get('totalPages') ?? 0;
        setCurrentPage(currentPageUrl)
        setTotalPages(totalPagesUrl)
        setSortBy(sortByUrl)
        setPageSize(pageSizeUrl)
        fetchProduct()
        fetchCarManufacturers()
        fetchCarFilterConnections(sortByUrl, pageSizeUrl, currentPage)
    }, [])

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const sortByUrl = queryParams.get('sortBy') ?? '';
        const pageSizeUrl = queryParams.get('pageSize') ?? pageSize;
        const currentPageUrl = queryParams.get('currentPage') ?? 1;
        const totalPagesUrl = queryParams.get('totalPages') ?? 0;
        setCurrentPage(currentPageUrl)
        setTotalPages(totalPagesUrl)
        setSortBy(sortByUrl)
        setPageSize(pageSizeUrl)

        fetchCarFilterConnections(sortByUrl, pageSizeUrl, currentPage)
    }, [location.search, currentPage])

    const fetchProduct = async () => {
        try {
            const response = await fetch(`${API_URL}/item/realitem/${id}`, {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json',  // Specify the content type
                }
            })

            const result = await response.json()
            setProduct(result.data)
            setLoading(false)
        }
        catch (error) {
        }
    }

    const fetchCarManufacturers = async () => {
        try {
            const response = await fetch(`${API_URL}/car/cars`)

            const result = await response.json()
            setCarManufacturers(result.data)
            setLoading(false)
        }
        catch (error) {
        }
    }

    useEffect(() => {
        if (selectedCarManufacuturer) {
            fetchModels()
        }
    }, [selectedCarManufacuturer])

    const fetchModels = async () => {
        try {
            setLoading(true)
            const response = await fetch(`${API_URL}/car/carModels?carManufacturerId=${selectedCarManufacuturer}`)

            const result = await response.json()

            setCarModels(result.data)
            setLoading(false)
        }
        catch (Error) {
        }
    }

    useEffect(() => {
        if (selectedCarModel) {
            fetchEngines()
        }
    }, [selectedCarModel])


    const fetchEngines = async () => {
        try {
            setLoading(true)
            const response = await fetch(`${API_URL}/car/modelEngines?carModelId=${selectedCarModel}`)

            const result = await response.json()
            setCarEngines(result.data)
            setLoading(false)
        }
        catch (error) {
        }
    }

    const handleManufacturerChange = (e) => {


        const selectedMake = tryParseJSON(e.target.value)
        setSelectedCarManufacuturer(selectedMake)
        setCarModels([])
        setCarEngines([])
        setSelectedCarModel('')
        setSelectedEngineId('')
    };

    const handleCarModelChange = (e) => {
        setSelectedEngineId('')

        setSelectedCarModel(e.target.value)
    }

    const openAddModal = () => {
        setNewCarConnection(
            {
                itemId: product.id,
                filterRequests: [
                    {
                        
                    }
                ]
            }
        )

        setIsModalOpen(true);
    };

    const tryParseJSON = (value) => {
        try {
            return JSON.parse(value);
        } catch (e) {
            return null; // Return null or handle the error as needed
        }
    }

    const closeAddModal = () => {
        setIsModalOpen(false);
        setSelectedCarManufacuturer('')
        setSelectedCarModel('')
        setSelectedEngineId('')
        setDescription('')
    };
    const handleConnectionAdd = async () => {
        setLoading(true);
        // Осигурувај се дека за секој запис има пополнето itemId
        const validFilterRequests = newCarConnection.filterRequests.map(request => ({
            ...request,
            itemId: product.id  
        }));

        const validCarConnection = {
            ...newCarConnection,
            filterRequests: validFilterRequests,
        };

        const response = await fetch(`${API_URL}/CarFilterConnection/connectCarFilters`, {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(validCarConnection),
        });

        const result = await response.json();

        if (result.statusCode === 200) {
            fetchCarFilterConnections();
            closeAddModal();
        }
        setLoading(false);
    };

    const fetchCarFilterConnections = async (sortBy, pageSize, currentPage) => {
        setLoading(true)
        const response = await fetch(`${API_URL}/CarFilterConnection/getFilterConnectionsByItemId?itemId=${id}&sortBy=${sortBy}&pageNumber=${currentPage}&pageSize=${pageSize}`, {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',  // Specify the content type
            }
        })

        const result = await response.json()
        
        if (result.statusCode === 200) {

            setCarConnections(result.data.items)
            setTotalPages(result.data.totalPages);
            setTotalItems(result.data.totalItems);
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const openDeleteModal = (car) => {
        setCarToDelete(car);
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setCarToDelete(null);
    };

    const confirmDelete = () => {
        deleteCar(carToDelete);
    };

    const deleteCar = async (car) => {
        setLoading(true);

        const response = await fetch(`${API_URL}/CarFilterConnection/${car.id}`, {
            method: 'DELETE',
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',  // Specify the content type
            }
        })
        const result = await response.json()
        if (result.statusCode === 204) {
            toast.success(`${car.id} е успешно избришан!`);
            setCarConnections(carConnections.filter((item) => item.id !== car.id));
            setLoading(false);
            closeDeleteModal();
        } else {
            toast.warning(`${product.title} не е успешно избришан!`);
            setLoading(false);
            closeDeleteModal();
        }
    }

    const openEditModal = (car) => {
        setSelectedCar(car)
        setEditModalOpen(true);
    };

    const closeEditModal = () => {
        setEditModalOpen(false);
        setSelectedCar(null);
    };

    const handleCar = async () => {
        setLoading(true)

        const response = await fetch(`${API_URL}/CarFilterConnection/${selectedCar.id}?description=${selectedCar.additionalDescription}`, {
            method: 'PUT',
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',  // Specify the content type
            },
            body: JSON.stringify(selectedCar),
        })

        const result = await response.json()
        if (result.statusCode === 204) {
            setCarConnections(carConnections.map(car =>
                car.id === selectedCar.id ? selectedCar : car
            ));
            closeEditModal();
            setLoading(false)
            toast.success(`${selectedCar.carEngine.carModel.carManufacturer.manufacturer} ${selectedCar.carEngine.description} ${selectedCar.carEngine.modelYear} е успешно ажуриран!`);
        } else {
            setLoading(false)
        }
    };

    const handlePageChange = (page) => {
        const newQueryParams = new URLSearchParams(location.search);

        if (page) {
            newQueryParams.set('currentPage', page);
        } else {
            newQueryParams.delete('currentPage');
        }
        navigate({ search: newQueryParams.toString() });

        setCurrentPage(page)
    };

    const handleEngineCheckboxChange = (e, engine) => {
        const isChecked = e.target.checked;
        setNewCarConnection(prevState => {
            const filterRequests = [...prevState.filterRequests];
            
            if (isChecked) {
                // Додај нов запис за мотор ако е избран
                if (engine.id !== 0) {
                    filterRequests.push({
                        carEngineId: engine.id,
                        itemId: product.id,  // Постави itemId ако не е дефинирано
                        additionalDescription: ""
                    });
                }
            } else {
                // Уништи мотор ако не е избран
                const index = filterRequests.findIndex(request => request.carEngineId === engine.id);
                if (index !== -1) filterRequests.splice(index, 1);
            }

            return { ...prevState, filterRequests };
        });
    };

    const handleEngineDescriptionChange = (e, engine) => {
        const { value } = e.target;
        setNewCarConnection(prevState => {
            const filterRequests = prevState.filterRequests.map(request =>
                request.carEngineId === engine.id
                    ? {
                        ...request,
                        additionalDescription: value,
                        itemId: product.id  // Постави itemId ако не е дефинирано
                    }
                    : request
            );

            return { ...prevState, filterRequests };
        });
    };

    // if (loading) {
    //     return <p>Loading...</p>
    // }

    if (!product) {
        return <p>Продуктот не е пронајден</p>
    }

    return (
        <div>
            <div className='flex flex-wrap w-full'>
                <Link to={-1} className='mr-2 '>
                    <button className='btn btn-third btn-sm'>
                        <FontAwesomeIcon className='text-xl' icon={faArrowLeft} /> Врати се назад
                    </button>
                </Link>
                <button className='btn btn-primary mb-4 btn-sm' onClick={openAddModal}>
                    <FontAwesomeIcon icon={faPlus} />
                    Додади нова конекција
                </button>
            </div>
            <div className='flex justify-between flex-col md:flex-row'>
                <div className={`card w-full bg-base-100 shadow-xl bg-orange-300  max-w-[250px] mt-20 max-h-fit`}>
                    <figure><img src={product.imageLinks?.[0]?.imageLink} alt={`${product.title}`} /></figure>
                    <div className="card-body flex flex-col justify-center items-center text-center p-4">
                        <h2 className="card-title break-words">Продукт: {product.title}</h2>
                        <h6 className="break-words">Производител: {product.manufacturer}</h6>
                        <h6 className="break-words">Број на производ: {product.itemNumber}</h6>
                        <h6 className="break-words">Тип: {product.type}</h6>
                    </div>
                </div>
                <div className='max-w-[70%]'>
                    <div className="mt-6">
                        <h2 className="text-2xl font-bold mb-6">Додадени автомобили - {totalItems}</h2>
                        <hr />
                        <ul>
                            {carConnections.map((car) => (
                                <li key={car.id} className="mb-4">
                                    <div className='w-full flex'>
                                        <div className="tooltip ml-auto" data-tip="Избриши ја конекцијата">
                                            <button
                                                className="btn btn-xs btn-error"
                                                onClick={() => openDeleteModal(car)}
                                            >
                                                <FontAwesomeIcon icon={faTrashCan} />
                                            </button>
                                        </div>
                                        <div className="tooltip" data-tip="Измени го описот">
                                            <button
                                                className="btn btn-xs btn-primary ml-2"
                                                onClick={() => openEditModal(car)}
                                            >
                                                <FontAwesomeIcon icon={faPenToSquare} />
                                            </button>
                                        </div>
                                    </div>
                                    <div><strong>Марка:</strong> {car.carEngine.carModel.carManufacturer.manufacturer}</div>
                                    <div>
                                        <strong>Модел:</strong> {car.carEngine.carModel.modelType} ({car.carEngine.carModel.code}) ({car.carEngine.carModel.yearRangeProduction})
                                    </div>
                                    <div>
                                        <strong>Детали за мотор:</strong> {car.carEngine.model} {car.carEngine.description} - {car.carEngine.kw} / {car.carEngine.hp} ({car.carEngine.modelYear})
                                    </div>
                                    <div><strong>Опис:</strong> {car.additionalDescription}</div>
                                    <hr />
                                </li>
                            ))}
                        </ul>
                    </div>
                    {carConnections.length > 0 && (
                        <><div>Тековна страна: {currentPage}</div>
                            <Pagination
                                totalPages={totalPages}
                                currentPage={currentPage}
                                onPageChange={handlePageChange}
                            /></>
                    )}
                </div>
            </div>
            {isModalOpen && (
                <div className="modal modal-open">
                    <div className="modal-box max-w-[800px]">
                        <div className="flex items-center justify-center p-4 flex-wrap">
                            <div className="mx-auto w-full bg-white mb-auto">
                                <div>
                                    <h1 className='text-4xl font-bold mb-8 mt-8 text-center'>Додај нов автомобил</h1>
                                </div>
                                <div className='flex flex-wrap justify-center items-center mb-2'>
                                    <div className='mr-4 width-max'>
                                        <select name='cmfr' value={selectedCarManufacuturer} onChange={handleManufacturerChange} className="select select-bordered w-[300px] max-w-xs mb-5 select-sm" disabled={loading ? 'disabled' : ''}>
                                            <option value='' defaultValue>Одберете марка</option>
                                            {carManufacturers.map((car) => (
                                                <option key={car.id} value={JSON.stringify(car.id)}>{car.manufacturer}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='mr-4 width-max'>
                                        <select name='cmd' value={selectedCarModel} onChange={handleCarModelChange} className="select select-bordered w-[300px] max-w-xs mb-5 select-sm" disabled={loading ? 'disabled' : ''}>
                                            <option value='' defaultValue>Одберете модел</option>
                                            {carModels.map((car) => (
                                                <option key={car.id} value={car.id}>{car.modelType} ({car.code}) ({car.yearRangeProduction})</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h3 className="text-xl font-semibold mb-2">Изберете мотори</h3>
                                    {carEngines.map((engine) => (
                                        <div key={engine.id} className="flex items-center mb-4">
                                            <input
                                                type="checkbox"
                                                id={`engine-${engine.id}`}
                                                value={engine.id}
                                                checked={newCarConnection.filterRequests.some((request) => request.carEngineId === engine.id)}
                                                onChange={(e) => handleEngineCheckboxChange(e, engine)}
                                                disabled={loading}
                                                className="mr-2"
                                            />
                                            <label htmlFor={`engine-${engine.id}`} className="text-base">{`${engine.model} ${engine.description} - ${engine.kw} / ${engine.hp} (${engine.modelYear})`}</label>

                                            {/* Textbox for description under each engine */}
                                            {newCarConnection.filterRequests.some((request) => request.carEngineId === engine.id) && (
                                                <textarea
                                                    placeholder="Додадете опис за овој мотор"
                                                    value={newCarConnection.filterRequests.find((request) => request.carEngineId === engine.id)?.additionalDescription || ''}
                                                    onChange={(e) => handleEngineDescriptionChange(e, engine)}
                                                    className="textarea textarea-bordered w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md mt-2"
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="modal-action">
                            {loading && (<span className="loading loading-spinner loading-xs"></span>)}
                            <button className="btn btn-success" onClick={handleConnectionAdd} disabled={loading}>Зачувај</button>
                            <button className="btn btn-warning" onClick={closeAddModal} disabled={loading}>Откажи</button>
                        </div>
                    </div>
                </div>
            )}
            {isDeleteModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                    <div className="modal modal-open">
                        <div className="modal-box">
                            <h3 className="text-xl font-semibold">Дали сте сигурни дека сакате да го избришите <span className='font-bold text-2xl'></span>?</h3>
                            <div className="modal-action">
                                <button
                                    onClick={confirmDelete}
                                    className="btn btn-error"
                                    disabled={loading}
                                >
                                    Избриши
                                </button>
                                <button
                                    onClick={closeDeleteModal}
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    Откажи
                                </button>
                                {loading && (<span className="loading loading-spinner loading-xs"></span>)}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {editModalOpen && selectedCar && (
                <div className="modal modal-open">
                    <div className="modal-box max-w-[500px]">
                        <div className="flex items-center justify-center p-4 flex-wrap">
                            <div className="mx-auto w-full bg-white mb-auto">
                                <div>
                                    <h2 className='text-4xl font-bold mb-8 mt-8 text-center'>Промени податоци за овој автомобил</h2>
                                </div>
                                <div className="-mx-3 flex flex-wrap">
                                    <label htmlFor="additionalDescription" className="mb-3 block text-base font-medium text-[#07074D]">
                                        Опис
                                    </label>
                                    <textarea type="textarea" name="additionalDescription" id="additionalDescription" value={selectedCar.additionalDescription}
                                        required
                                        onChange={(e) => setSelectedCar({ ...selectedCar, additionalDescription: e.target.value })}
                                        className="textarea textarea-bordered w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" ></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="modal-action">
                            {loading && (<span className="loading loading-spinner loading-xs"></span>)}
                            <button className="btn btn-success" onClick={handleCar} disabled={loading}>Зачувај</button>
                            <button className="btn btn-warning" onClick={closeEditModal} disabled={loading}>Откажи</button>
                        </div>
                    </div>
                </div>
            )
            }
        </div>
    )
}

export default CarFilterConnectionTest1
